import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterInitialRender } from 'owa-delayed-initialization';
import 'owa-fms-action-handlers/lib/orchestrators/turnOffFocusedInbox';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "LightningView" */ './lazyIndex');
});
var lazyLoadLightningPrimaryView = new LazyAction(lazyModule, function (m) { return m.loadLightningPrimaryView; });
runAfterInitialRender(function () {
    lazyLoadLightningPrimaryView.importAndExecute();
});
//# sourceMappingURL=index.js.map